// @flow
import { takeEvery, call, put, spawn } from 'redux-saga/effects';
import {
  PRODUCTS,
  receiveCartProducts,
  setFavorites,
} from 'pages/MyAccount/services/actions/productsActions';
import { setCartData, failedCartRequest } from 'pages/MyAccount/services/actions/cartActions';
import {
  receiveSearchTerms,
  receiveSearchTermsError,
} from 'pages/MyAccount/services/actions/searchActions';
import { receiveCategories } from 'pages/MyAccount/services/actions/categoriesActions';
import { getCategories, getSearchTerms } from 'pages/MyAccount/services/api/sale';
import { getCartData } from 'pages/MyAccount/services/api/carts';
import { getFavoritesData } from 'pages/MyAccount/services/api/products';

const { REQUEST_FAVORITES } = PRODUCTS;

// watcher sagas
export function* watchFetchSaleData() {
  yield takeEvery(REQUEST_FAVORITES, fetchFavoritesData);
}

// worker sagas
// These are calls made when the sale page loads
export function* fetchSaleData() {
  /* using spawn so that these workers stay independent of each other even if they fail.
    https://redux-saga.js.org/docs/advanced/ForkModel.html#detached-forks-using-spawn */
  yield spawn(fetchFavoritesData);
  yield spawn(fetchCartData); // we need cart data for product cards
  yield spawn(fetchCategories);
  yield spawn(fetchSearchTerms);
}

function* fetchCategories() {
  const categoriesResponse = yield call(getCategories);
  yield put(receiveCategories(categoriesResponse.categories));
}

function* fetchFavoritesData() {
  const favortiesData = yield call(getFavoritesData);
  yield put(setFavorites(favortiesData));
}

export function* fetchCartData() {
  /* using try catch here so that if this worker SAGA fails, 
  it prevents the user from seeing the cart. */
  try {
    const cartData = yield call(getCartData);
    const { products, variants, cartDetails } = cartData;

    yield put(receiveCartProducts({ products, variants }));
    yield put(setCartData(cartDetails));
  } catch {
    yield put(failedCartRequest());
  }
}

function* fetchSearchTerms() {
  try {
    const response = yield call(getSearchTerms);
    const {
      data: { items },
    } = response;
    yield put(receiveSearchTerms(items));
  } catch (err) {
    yield put(receiveSearchTermsError(err));
  }
}
